'use client';

import { getLooselyTypedUtag, useThirdPartyEvent } from '@tuic/lib/src/client';

export const FooterCookieSettingsOpener = () => {
  const { listen } = useThirdPartyEvent('openCookieSettings');

  listen(() => getLooselyTypedUtag(window).gdpr.showConsentPreferences());

  return null;
};
